// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"c2588d92","488":"74c06dd0"}[chunkId] + ".chunk.js";
};